import React, { useEffect, useState } from 'react';
import Banner from '../../components/Banner';
import { getActiveNews } from '../../api/news';
import styles from '../../css/newsRoom.module.css';
import newsRoom from '../../assets/images/news-room-banner.png';



const NewsRoom = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch news data when component mounts
  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const newsData = await getActiveNews();
        setArticles(newsData);
        setError('');
      } catch (err) {
        console.error('Failed to fetch news:', err);
        setError('Failed to load news articles. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const dateOptions = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric'
    };
    const timeOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
    return `${formattedDate} | ${formattedTime}`;
  };

  // Create excerpt from full text
  const createExcerpt = (text, maxLength = 150) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };
  return (
    <div className="main-container">
      <Banner
        image={newsRoom}
        altText="Newsroom"
        className="newsroom-banner"
      >
      </Banner>
  
        <section className={styles.section1}>
          <div className="container">
           <p className="comp-desc">HiveRooms is more than just a hospitality technology solution; it’s now a travel marketplace
              where you can book your accommodations, travel experiences, and events in one platform.</p>
          </div>
        </section>

        <section className={styles.section2}>
            <div className="comp-categories">
                <p className={styles.desc}>Discover the latest features and stories about HiveRooms in the media.</p>
            </div>
        </section>

        <section className={styles.section3}>
            <div className="container">
                {loading && (
                    <div className={styles.loading}>
                        <p>Loading news articles...</p>
                    </div>
                )}
                
                {error && (
                    <div className={styles.error}>
                        <p>{error}</p>
                    </div>
                )}

                {!loading && !error && articles.length === 0 && (
                    <div className={styles.noArticles}>
                        <p>No news articles available at the moment.</p>
                    </div>
                )}

                {!loading && !error && articles.length > 0 && (
                    <div className={styles.cardsWrapper}>
                        {articles.map((article) => (
                            <div className={styles.card} key={article._id}>
                                <img 
                                    src={article.imageUrl} 
                                    alt={article.title}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                                <h3>{article.title}</h3>
                                <p className={styles.date}>{formatDate(article.dateTime)}</p>
                                <p>{createExcerpt(article.text)}</p>
                                <a
                                    href={article.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.readMore}
                                >
                                    Read more →
                                </a>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </section>
    </div>
  );
};

export default NewsRoom;